import AntiFraudToolAdminItem from '../Domain/AntiFraudToolAdminItem';
import FraudHitEvaluatorItem from '../Domain/FraudHitEvaluatorItem';
import FraudHitEvaluatorMatchItem from '../Domain/FraudHitEvaluatorMatchItem';
import objectHelper from '../Helpers/objectHelper';
import AuthService from './authService';
import SearchParams from '../Elements/SearchParams';
import AntiFraudToolSearchParams from '../Contents/Operations/AntiFraudTool/AntiFraudToolSearchParams';
import FraudHitEvaluatorSearchParams from '../Contents/Operations/AntiFraudTool/FraudHitEvaluatorSearchParams';
import FraudHitMatchSearchParams from '../Contents/Operations/AntiFraudTool/FraudHitMatchSearchParams';

export default class AntiFraudToolService {
  static GetById(id) {
    const authService = AuthService.getInstance();
    const url = `/api//AntiFraudTool/GetByIdAsync/${id}`;
    return authService.CallBackendFunction(url);
  }

  static GetFraudHits(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, AntiFraudToolSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/AntiFraudTool/GetAllBySearchingAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    return itemlist !== null ? itemlist.map((item) => new AntiFraudToolAdminItem(item)) : [];
  }

  static GetBaseEvaluator(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = true) {
    const searchParams = new SearchParams(searchItem, FraudHitEvaluatorSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/AntiFraudTool/GetBaseEvaluatorAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=true`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetAllEvaluatorsBySearching(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = new SearchParams(searchItem, FraudHitEvaluatorSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/AntiFraudTool/GetAllEvaluatorsBySearchingAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=true`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertHitEvaluatorDBItemList(itemlist) {
    return itemlist !== null ? itemlist.map((item) => new FraudHitEvaluatorItem(item)) : [];
  }

  static GetAllMatchesBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, FraudHitMatchSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/AntiFraudTool/GetAllMatchesBySearchingAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertMatchesDBItemList(itemlist) {
    return itemlist !== null ? itemlist.map((item) => new FraudHitEvaluatorMatchItem(item)) : [];
  }

  static ChangeFraudStatus(item) {
    const string = objectHelper.toString(item);
    const json = JSON.stringify(string);
    return AuthService.getInstance().CallBackendFunctionPut('/api/AntiFraudTool/ChangeFraudStatusAsync/', json);
  }
}
